import { JSX } from 'react'

import { IconProps } from '../../icon'

const Template: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M33.2051 10H16.7949C12.4954 10 9 13.4954 9 17.7949V30.9231C9 35.2226 12.4954 38.7179 16.7949 38.7179H33.2051C37.5046 38.7179 41 35.2226 41 30.9231V17.7949C41 13.4954 37.5046 10 33.2051 10ZM22.9487 19.0256H38.5385V26.4103H22.9487V19.0256ZM16.7949 12.4615H33.2051C35.7159 12.4615 37.8164 14.2174 38.3744 16.5641H11.6256C12.1836 14.2174 14.2841 12.4615 16.7949 12.4615ZM11.4615 30.9231V19.0256H20.4872V36.2564H16.7949C13.8574 36.2564 11.4615 33.8605 11.4615 30.9231ZM33.2051 36.2564H22.9487V28.8718H38.5385V30.9231C38.5385 33.8605 36.1426 36.2564 33.2051 36.2564Z'
      fill='black'
    />
  </svg>
)

export default Template
